import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@design-system/button';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __ } from '@design-system/i18n';
import { Dropdown } from './Dropdown';
const chevronIcon = (isOpen) => (_jsx(FontAwesomeIcon, { height: "12px", iconName: isOpen ? 'angle-up' : 'angle-down', iconType: CATEGORIES.SOLID }));
export const DropdownChevronButton = (_a) => {
    var { screenReadersText = __('Open dropdown'), variant = 'secondary' } = _a, props = __rest(_a, ["screenReadersText", "variant"]);
    return (_jsx(Dropdown, Object.assign({}, props, { children: ({ isOpen }) => (_jsx(Button, Object.assign({ icon: () => chevronIcon(isOpen), isDisabled: props.isDisabled, screenReadersText: screenReadersText, type: null, variant: variant }, (!props.isDisabled && { as: 'span' })))) })));
};
//# sourceMappingURL=DropdownChevronButton.js.map